import { useCallback, useEffect, useRef, useState } from "react";

const RADIO = 'input[type="radio"]:not(:disabled)';
// O InputText do Prime não renderiza type="text".
const CAMPO = "input:not([type]):not(:disabled), textarea:not(:disabled)";

/**
 * Leva o foco e a rolagem ao primeiro campo com erro de validação do corpo do modal.
 * O VM chama `focarPrimeiroInvalido` ao recusar avançar; a View só liga `corpoRef`.
 */
export function useFocoPrimeiroInvalido<T extends HTMLElement = HTMLDivElement>() {
  const corpoRef = useRef<T>(null);
  const [tentativa, setTentativa] = useState(0);

  const focarPrimeiroInvalido = useCallback(() => setTentativa((atual) => atual + 1), []);

  useEffect(() => {
    if (tentativa === 0) return;
    const alerta = corpoRef.current?.querySelector<HTMLElement>('[role="alert"]');
    if (!alerta) return;
    // O alerta de grupo fica no fieldset; o da justificativa, ao lado do campo.
    const area = alerta.closest("fieldset") ?? alerta.parentElement;
    const alvo = area?.querySelector<HTMLElement>(RADIO) ?? area?.querySelector<HTMLElement>(CAMPO);
    alvo?.focus({ preventScroll: true });
    alerta.scrollIntoView?.({ block: "nearest" });
  }, [tentativa]);

  return { corpoRef, focarPrimeiroInvalido };
}
